export const MAPS_ETA_LINK_GET = "MAPS_ETA_LINK_GET";
export const MAPS_ETA_LINK_GET_RESPONSE = "MAPS_ETA_LINK_GET_RESPONSE";